export const isHiddenByParentElement = (parent) => {
  const parentStyle = window.getComputedStyle(parent);
  const parentRect = parent.getBoundingClientRect();

  if (
    (parentStyle.overflow === "hidden" || parentStyle.overflowY === "hidden") &&
    parentRect.height === 0
  ) {
    return true;
  } else return false;
};
